import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_viewportserver_23712d63 from 'nuxt_plugin_viewportserver_23712d63' // Source: ./viewport.server.js (mode: 'server')
import nuxt_plugin_viewportclient_8490884a from 'nuxt_plugin_viewportclient_8490884a' // Source: ./viewport.client.js (mode: 'client')
import nuxt_plugin_markdownit_65bbd3b4 from 'nuxt_plugin_markdownit_65bbd3b4' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_workbox_4c220b18 from 'nuxt_plugin_workbox_4c220b18' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_5e9ee4f2 from 'nuxt_plugin_metaplugin_5e9ee4f2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_554f9a0a from 'nuxt_plugin_iconplugin_554f9a0a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_globals_23f2b60c from 'nuxt_plugin_globals_23f2b60c' // Source: ../plugins/globals (mode: 'all')
import nuxt_plugin_markdownit_69ef6b60 from 'nuxt_plugin_markdownit_69ef6b60' // Source: ../plugins/markdownit (mode: 'all')
import nuxt_plugin_refactorredirects_36f97b42 from 'nuxt_plugin_refactorredirects_36f97b42' // Source: ../plugins/refactor-redirects (mode: 'all')
import nuxt_plugin_utmtracking_85780b28 from 'nuxt_plugin_utmtracking_85780b28' // Source: ../plugins/utm-tracking (mode: 'all')
import nuxt_plugin_lazygtm_af7df686 from 'nuxt_plugin_lazygtm_af7df686' // Source: ../plugins/lazy-gtm (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"de"},"title":"Pelletspreise aktuell: Pelletspreise vergleichen & günstig Pellets kaufen","script":[{"hid":"cookie-consent-script","data-cookieconsent":"ignore","innerHTML":"window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag(\"consent\", \"default\", { ad_personalization: \"denied\", ad_storage: \"denied\", ad_user_data: \"denied\", analytics_storage: \"denied\", functionality_storage: \"denied\", personalization_storage: \"denied\", security_storage: \"granted\", wait_for_update: 500, }); gtag(\"set\", \"ads_data_redaction\", true); gtag(\"set\", \"url_passthrough\", true);","type":"text\u002Fjavascript"},{"id":"Cookiebot","async":true,"src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","data-cbid":"5db6bfa5-71be-43a0-8813-8de8c1665acd","data-blockingmode":"auto","type":"text\u002Fjavascript"}],"__dangerouslyDisableSanitizersByTagID":{"cookie-consent-script":["innerHTML"]},"meta":[{"name":"theme-color","content":"#fdc835"},{"name":"author","content":"agital.online GmbH"},{"name":"publisher","content":"agital.online GmbH"},{"name":"verify-v1","content":"T9f3Bi6y1ufxLrzNQ7oAxjGUmjrZDr3SWT9vyhZeCRI="},{"name":"google-site-verification","content":"z27MaXaF2q74sFE87IW4G-Y2aR5ZTzsgKjCyrlwbdJs"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover"},{"name":"apple-itunes-app","content":"app-id=692787071"},{"name":"google-play-app","content":"app-id=com.esyoil.webapp2c"},{"name":"page-type","content":"Holzpellets-Portal"},{"name":"audience","content":"all"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"\u002Ffavicon.ico"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"https:\u002F\u002Fconsent.cookiebot.com\u002F","rel":"preconnect"},{"rel":"preconnect","href":"https:\u002F\u002Fcf.esyoil.com","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Fcf.esyoil.com\u002Fassets\u002Ffonts\u002Fmontserrat\u002FJTUSjIg1_i6t8kCHKm459Wlhyw.woff2","crossorigin":"anonymous"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_viewportserver_23712d63 === 'function') {
    await nuxt_plugin_viewportserver_23712d63(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_viewportclient_8490884a === 'function') {
    await nuxt_plugin_viewportclient_8490884a(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_65bbd3b4 === 'function') {
    await nuxt_plugin_markdownit_65bbd3b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4c220b18 === 'function') {
    await nuxt_plugin_workbox_4c220b18(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5e9ee4f2 === 'function') {
    await nuxt_plugin_metaplugin_5e9ee4f2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_554f9a0a === 'function') {
    await nuxt_plugin_iconplugin_554f9a0a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_23f2b60c === 'function') {
    await nuxt_plugin_globals_23f2b60c(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_69ef6b60 === 'function') {
    await nuxt_plugin_markdownit_69ef6b60(app.context, inject)
  }

  if (typeof nuxt_plugin_refactorredirects_36f97b42 === 'function') {
    await nuxt_plugin_refactorredirects_36f97b42(app.context, inject)
  }

  if (typeof nuxt_plugin_utmtracking_85780b28 === 'function') {
    await nuxt_plugin_utmtracking_85780b28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazygtm_af7df686 === 'function') {
    await nuxt_plugin_lazygtm_af7df686(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
